import store from 'store';

import { AmplitudeAPI } from './amplitude/amplitude-api';

export const ANALYTIC_EVENTS = {
  ZakazatDostavku: 'Zakazat_dostavku', // нажатие на кнопку "Заказать доставку"
  redirect: 'REDIRECT', // Перенаправление клиента по URL, полученному с сервера
  viewError: 'VIEW_ERROR', // Ошибка получения данных транзакции с сервера
  viewSuccess: 'VIEW_SUCCESS', // Успешное получение данных транзакции с сервера
  processingError: 'PROCESSING_ERROR', // Данные транзакции успешно отправлены
  processingSuccess: 'PROCESSING_SUCCESS', // Данные транзакции отклонены или не были отправлены
  sentKaspiCodeError: 'SENT_KASPI_CODE_ERROR', // Код с подтверждение для каспи не был отправлен или не принят
  sentKaspiCodeSuccess: 'SEND_KASPI_CODE', // Код с подтверждение для каспи успешно отправлен
  pageKaspiConfirm: 'PAGE_KASPI_CONFIRM', // Экран подтверждения для каспи
  pageError: 'PAGE_PAY_ERROR', // Транзакция отклонена
  getStatusSuccess: 'GET_STATUS_SUCCESS', // Запрос на получение статуса транзакции успешен
  getStatusError: 'GET_STATUS_ERROR', // Запрос на получение статуса транзакции получил ошибку
  mailSendSuccess: 'MAIL_SEND_SUCCESS', // почта в поддержку отправлена
  mailSendError: 'MAIL_SEND_ERROR', // почта в поддержку не отправлена
  checkSendSuccess: 'CHECK_SEND_SUCCESS', // почта для получения чека отправлена
  checkSendError: 'CHECK_SEND_ERROR', // почта для получения чека не отправлена
  antiFraudPayFail: 'ANTI_FRAUD_PAY_FAIL', // Экран с отклоненной транзакцией(сервер посчитал подозрительной)
  pageCheck: 'PAGE_CHECK', // Экран чека
  pageCheckHold: 'PAGE_CHECK_HOLD', // Экран с чеком на холде
  pageTerminalCheck: 'PAGE_TERMINAL_CHECK', // Экран инструкции по оплате в терминале
  pageConfirm: 'PAGE_CONFIRM', // Перенаправление в банк
  pageConfirmSecond: 'PAGE_CONFIRM_SECOND', // Повторное перенаправление в банк(только с каспи)
  pagePaymentForm: 'PAGE_PAYMENT_FORM', // Экран оплаты(выплаты)
  pagePayNotFound: 'PAGE_PAY_NOT_FOUND', // Экран с сообщением, что транзакция не наидена
  pageServerError: 'PAGE_SERVER_ERROR', // Экран с сообщением, что возникли проблемы на сервере
  clickPayBtnDisable: 'CLICK_PAY_BTN_DISABLE', // Нажатие кнопки оплатить в заблокированном состоянии
  clickPayBtnEnable: 'CLICK_PAY_BTN_Enable', // Нажатие кнопки оплатить в разрешенном состоянии
  getCertSuccess: 'GET_CERT_SUCCESS', // Сертификат для шифрования карт получен успешно
  getCertError: 'GET_CERT_ERROR', // Сертификат для шифрования карт не получен
  getCommissionSuccess: 'GET_COMMISSION_SUCCESS', // Расчет комиссии успешен(только инвоисы)
  getCommissionError: 'GET_COMMISSION_ERROR', // Не удалось рассчитать комиссию(только инвоисы)
  panError: 'PAN_ERROR', // Номер карты введен с ошибкой
  panSuccess: 'PAN_SUCCESS', // Номер карты введен без ошибок
  validityError: 'VALIDITY_ERROR', // Срок действия карты введен с ошибкой
  validitySuccess: 'VALIDITY_SUCCESS', // Срок действия карты введен без ошибок
  cvvError: 'CVV_ERROR', // CVV код карты введен с ошибкой
  cvvSuccess: 'CVV_SUCCESS', // CVV код карты введен без ошибок
  cardholderError: 'CARDHOLDER_ERROR', // Владелец карты введен с ошибкой
  cardholderSuccess: 'CARDHOLDER_SUCCESS', // Владелец карты введен без ошибок
  paymentFormPlus24Pay: 'PAYMENT_FORM_PLUS24_PAY', // Выбран метод оплаты Plus24
  paymentFormPlus24PayOut: 'PAYMENT_FORM_PLUS24_PAY_OUT', // Выбран метод выплаты Plus24
  paymentFormTerminalPay: 'PAYMENT_FORM_TERMINAL_PAY', // Выбран метод оплаты TerminalKassa24
  paymentFormWebMoneyPay: 'PAYMENT_FORM_WEB_MONEY_PAY', // Выбран метод оплаты WebMoney
  paymentFormYandexMoneyPay: 'PAYMENT_FORM_YANDEX_MONEY_PAY', // Выбран метод оплаты YandexMoney
  paymentFormPayoutPhone: 'PAYMENT_FORM_PAYOUT_PHONE', // Выбран метод оплаты PayoutPhone
};

const getData = () => store.getState().payment.paymentData;

export class Analytics {
  static init() {
    AmplitudeAPI.getInit();
  }

  static sentEvent(event: string, eventProperties?: { [key: string]: string | null | number }) {
    const paymentData = getData();

    if (paymentData) {
      AmplitudeAPI.sendLogEvent(event, {
        transaction_id: paymentData.ID,
        ...eventProperties,
      });
    }
  }
}
